module.exports = __webpack_public_path__ + "img/motsu_nikomi.9f08babc.jpg";